import DeviceInfoRestModel from '@/api/RestModels/deviceInfo';

export default class DeviceInfo {
  constructor(store) {
    this.$store = store
  }

  async get() {
    try {
      return await DeviceInfoRestModel.get();
    } catch (err) {
      return null;
    }
  }
}
